<template>
  <div class="search-result d-flex align-items-center mx-2 px-2 py-1" @click="click" :class="{'active': isActive, 'disabled': resultIsCurrentNote}">
    <span class="badge badge-light mr-2" v-if="resultIsCurrentNote">current</span>
    <span class="result-title flex-shrink-0 mr-auto" v-html="title"></span>
    <!-- <span class="badge badge-secondary mr-4" v-if="result.links.from.length > 0">
      <i class="fas fa-sign-in-alt mx-1"></i>
      {{result.links.from.length}}
    </span> -->
    <!-- <span class="result-preview"></span> -->
    <span class="result-modified flex-shrink-0">{{formatModified(result.modified)}}</span>
  </div>
</template>
<script>
import { distanceInWords, format, isToday } from 'date-fns'

export default {
  props: ['result', 'activeResult', 'query', 'currentNote'],
  computed: {
    resultIsCurrentNote() {
      return this.currentNote.id === this.result.id
    },
    isActive() {
      return this.result.id === this.activeResult.id
    },
    title() {
      const replaceTo = '<span class="text-primary bg-light">$&</span>'
      return this.result.title.replace(new RegExp(this.query, 'ig'), replaceTo)
    }
  },
  methods: {
    formatModified(timestamp) {
      let dateDistanceInWords = distanceInWords(
        new Date(timestamp),
        new Date()
      ) + ' ago'

      return isToday(timestamp) ? dateDistanceInWords : format(timestamp, 'D MMMM [at] HH:mm ')
    },
    click() {
      if (!this.resultIsCurrentNote) this.$emit('click')
    }
  }
}
</script>
<style lang="scss">
@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
.search-result {
  cursor: pointer;
  overflow: hidden;
  border-radius: $border-radius;
  font-size: 0.9rem !important;
  white-space: nowrap;
}
.search-result.active {
  background-color: $primary;
  color: $white;
}
.search-result:not(.active):hover {
  background-color: $gray-300;
}
.search-result:not(:last-child) {
  margin-bottom: $spacer * 0.25;
}
.result-title {
  max-width: 20%;
}
.disabled {
  cursor: default;
  opacity: 0.5;
  background-color: $gray-200;
}
</style>
